export default {
  computed: {
    /**
     * Determine based on level whether or not admin has ability to see edit and delete buttons.
     */
    filteredFields () {
      let level = this.admin.level

      return this.fields.map((field) => {
        let key = field.key

        if (key !== 'edit' && key !== 'delete') {
          return field
        }

        if ((key === 'edit' || key === 'delete') && level <= 1) {
          return field
        }
      })
    }
  }
}
